module.exports = __webpack_public_path__ + "res/img_card_bg.327900fef581fc06506f6e2991228c0f.png";